import Swiper, {Navigation, EffectFade} from "swiper";

const Slider = (element: HTMLElement) =>
	new Swiper(element, {
		modules: [EffectFade, Navigation],
		autoHeight: true,
		slidesPerView: 1,
		spaceBetween: 32,
		centerInsufficientSlides: true,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

export default () => {
	const sliders: HTMLElement[] = Array.from(
		document.querySelectorAll(".block.testimonials .slider")
	);

	if (!sliders) return;

	sliders.map((element: HTMLElement) => Slider(element));
};
